import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from '@kpmg-tax/ui';
import { LegalEntitiesService } from 'src/app/data-analysis-summary/legal-entity/legal-entity.service';
import { API_URL } from '../../constants/apiurl-constants';
import { Messages } from '../../constants/messages';
import { encodeText } from '../../lib/custom-tools';
import { BaseResponse } from '../../models/base-response.model';
import { LegalEntities } from '../../models/legal-entity/legal-entity.model';
import { SessionService } from '../../session-service/session.service';
import { RightSideDrawerService } from '../right-side-drawer.service';

@Component({
  selector: 'add-an-entity',
  templateUrl: './add-an-entity.component.html',
  styleUrls: ['./add-an-entity.component.scss']
})
export class AddAnEntityComponent implements OnInit {
  engagementId: number;
  targetForm: FormGroup;
  legalEntities:LegalEntities[];
  entitynameNoError: boolean=false;
  entityname: any;
  isDisabled: boolean=false;
  isEntityValueEntered: boolean= false;

  constructor(public rightSideDrawerService: RightSideDrawerService,
    public sessionService: SessionService,private formBuilder: FormBuilder,
    private _toasterService:ToastrService, private _legalEntityService:LegalEntitiesService) { }
    public resetRightSideDrawerData = () => {
      this.targetForm.reset();
    }
  ngOnInit(): void {
    this.engagementId = parseInt(this.sessionService.getSession('engagementId'));
    this.legalEntities = this.rightSideDrawerService.multipleRowAddData;
    console.log(this.legalEntities);
    if ((this.rightSideDrawerService.singleRowEditData == null) || (typeof this.rightSideDrawerService.singleRowEditData === 'undefined')) {
      this.resetRightSideDrawerDataAdd();
    }
    // this.targetForm = this.formBuilder.group({
    //   entityname: ['',[
    //     Validators.required,
    //     Validators.maxLength(100),
    //     this.UniqueActivityNameAdd(this.legalEntities),
    //   ]],
    //   ein:[''],
    //   businessactivitycode:['']
      
      
      
    // });
  }

  public buildFrom(activity) {
    this.rightSideDrawerService.multipleRowAddData = activity;
  }
  public resetRightSideDrawerDataAdd = () => {
    this.targetForm = this.formBuilder.group({
      
      entityname: ['',[
        Validators.required,
        Validators.maxLength(100)
      ]],
      ein:[''],
      businessactivitycode:['']
     
    });
  }
  get f() {
    return this.targetForm?.controls;
  }
  get inputEntityName(): string {
    return this.trim(this.targetForm.get('entityname').value?.toString().trim());
  }
  checkEntityName() {
    this.entityname = this.legalEntities.filter(x => x.legalEntityName.toUpperCase() === this.inputEntityName.toUpperCase())
   if(this.entityname.length>0)
   {
     this.entitynameNoError=true;
     
   }
   else
   {
    this.entitynameNoError=false;
    
    
   }
    
  }
  UniqueActivityNameUpdate(entityList: any, row: any) {
    return (control: AbstractControl): { [key: string]: any } => {
      const entityName = this.trim(control.value).toUpperCase();
      if (
        row.name.toUpperCase() !== entityName &&
        entityList.find(x => x.name.toUpperCase() === entityName) !== undefined
      ) {
        return { UniqueAName: true };
      }
      return null;
    };
  }

  
  trimSpecialChar(ctrl: any) {
    this.targetForm.controls[ctrl].setValue(
      this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-()._#!$%^+=&,*@/ ]/g, ''),
    );
  }
  UniqueActivityNameAdd(entityList: any) {
    return (control: AbstractControl): { [key: string]: any } => {
      const entityName = this.trim(control.value).toUpperCase();

      if (
        entityList.find(x => x.name.toUpperCase() === entityName) !== undefined
      ) {
        return { UniqueAName: true };
      }
      return null;
    };
  }
  trim(x) {
    //return x ? x.replace(/^\s+|\s+$/gm, '') : '';
   return x ? x.replace(/\s/g, ""):'';
  }
  AddEntity()
  {
    this.isDisabled = true;
  
    let entity: any = {
      legalentityname: encodeText(this.targetForm.get('entityname').value?.trim()),
      ein: encodeText(this.targetForm.get('ein').value?.trim()),      
      businessactivitycode: encodeText(this.targetForm.get('businessactivitycode').value?.trim()),
      engagementId: this.sessionService.getSession('engagementId'),
     
    };

    entity = this.sessionService.removeNullEmptyValues(entity);
    this.sessionService.apiUrlPost(API_URL.LEGAL_ENTITY.ADD_ENTITIES, entity).subscribe((data: BaseResponse) => {
      if (data.success) {
        this.rightSideDrawerService.closeRightSideDrawer();
        this._legalEntityService.refreshTable();
        let tabledata: Array<LegalEntities> = this._legalEntityService
          .legalEntities;
        
        tabledata.unshift(data.result);
        this._legalEntityService.legalEntities = [...tabledata];
      }
      this.rightSideDrawerService.closeRightSideDrawer();
      this._toasterService.setSuccessMessage(Messages.LEGAL_ENTITY.ADD_ENTITY);
    });
  }
  valueChanged() {
    let entityName = this.targetForm.get('entityname').value;
    
    if (
      entityName &&
      entityName.trim().length > 0
      
    ) {
      this.isEntityValueEntered = true;
    } else {
      this.isEntityValueEntered = false;
    }
  }
}
